import React, { createContext, useState, useContext } from 'react';
import '../../utils/responsive.es.js';
import { useKeyPressWithCallback } from '../../hooks/useKeyPress/useKeyPressWithCallback.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import '../../utils/assertions.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import { useEnhancedEffect } from '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'react-beautiful-dnd';
import 'nanoid/non-secure';
import '../../primitives/Box/Box.es.js';
import '../../primitives/Center/styled.es.js';
import '../../primitives/Group/Group.es.js';
import '../../primitives/Grid/Grid.es.js';
import Level from '../../primitives/Level/Level.es.js';
import '../../primitives/Shelf/Shelf.es.js';
import { Portal } from '../../primitives/Portal/Portal.es.js';
import '../../primitives/Hidden/Hidden.es.js';
import '../../primitives/Media/Media.es.js';
import '../../primitives/Dialog/Dialog.es.js';
import { ConditionalWrapper } from '../../primitives/ConditionalWrapper/ConditionalWrapper.es.js';
import '../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../primitives/Popper/Popper.es.js';
import '../../primitives/DragHandle/DragHandle.es.js';
import '../../primitives/Pin/Pin.es.js';
import { Overlay } from '../Overlay/Overlay.es.js';
import { DismissButton } from '../DismissButton/DismissButton.es.js';
import { Slide } from '../Slide/Slide.es.js';
import { TRANSITION_DURATION, Drawer as Drawer$2, Header as Header$1, Footer as Footer$1, Content as Content$1 } from './styled.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const DrawerContext = createContext({ onClose: () => void 0, isDismissable: true });
const Header = ({ children, showCloseButton = true }) => {
  const { onClose, isDismissable } = useContext(DrawerContext);
  return /* @__PURE__ */ React.createElement(Header$1, null, /* @__PURE__ */ React.createElement(ConditionalWrapper, {
    condition: isDismissable && showCloseButton,
    wrapper: (children2) => /* @__PURE__ */ React.createElement(Level, null, /* @__PURE__ */ React.createElement(Level.Left, null, children2), /* @__PURE__ */ React.createElement(Level.Right, null, /* @__PURE__ */ React.createElement(DismissButton, {
      variant: "subtle",
      kind: "minimal",
      onClick: onClose
    })))
  }, children));
};
const Footer = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React.createElement(Footer$1, __spreadValues({}, props), children);
};
const Content = (_c) => {
  var _d = _c, { children } = _d, props = __objRest(_d, ["children"]);
  return /* @__PURE__ */ React.createElement(Content$1, __spreadValues({}, props), children);
};
const Drawer = (_e) => {
  var _f = _e, {
    children,
    side = "bottom",
    isFull = false,
    isVisible = false,
    onClose = () => void 0,
    isDismissable = true,
    zIndex = 1e3
  } = _f, props = __objRest(_f, [
    "children",
    "side",
    "isFull",
    "isVisible",
    "onClose",
    "isDismissable",
    "zIndex"
  ]);
  const [isExited, setIsExited] = useState(true);
  const handleClose = () => {
    isDismissable && (onClose == null ? void 0 : onClose());
  };
  const handleEnter = () => {
    setIsExited(false);
  };
  const handleExited = () => {
    setIsExited(true);
  };
  useKeyPressWithCallback("Escape", handleClose);
  useEnhancedEffect(() => {
    if (!isVisible) {
      return;
    }
    const originalStyle = window.getComputedStyle(document.body).overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, [isVisible]);
  if (!isVisible && isExited) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(DrawerContext.Provider, {
    value: { onClose, isDismissable }
  }, /* @__PURE__ */ React.createElement(Portal, {
    zIndex
  }, /* @__PURE__ */ React.createElement(Overlay, {
    onClick: handleClose,
    isVisible,
    position: "fixed"
  }), /* @__PURE__ */ React.createElement(Slide, {
    in: isVisible,
    timeout: TRANSITION_DURATION,
    onEnter: handleEnter,
    onExited: handleExited,
    mountOnEnter: true,
    side
  }, /* @__PURE__ */ React.createElement(Drawer$2, __spreadValues({
    side,
    isFull,
    "aria-hidden": !isVisible
  }, props), children))));
};
Drawer.Header = Header;
Drawer.Footer = Footer;
Drawer.Content = Content;

export { Drawer };
//# sourceMappingURL=Drawer.es.js.map
